/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CoordinateSystem = {
    Unknown: 'Unknown',
    IecFixed: 'IecFixed',
    IecGantry: 'IecGantry',
    IecBeamLimitingDevice: 'IecBeamLimitingDevice',
    IecWedgeFilter: 'IecWedgeFilter',
    IecXRayImageReceptor: 'IecXRayImageReceptor',
    IecPatientSupport: 'IecPatientSupport',
    IecTableTopEccentricRotation: 'IecTableTopEccentricRotation',
    IecTableTop: 'IecTableTop',
    IecPatient: 'IecPatient',
    IecImager: 'IecImager',
    IecFocusOfImager: 'IecFocusOfImager',
    DicomPatientHeadFirstSupine: 'DicomPatientHeadFirstSupine',
    DicomPatientHeadFirstProne: 'DicomPatientHeadFirstProne',
    DicomPatientHeadFirstDecibitusRight: 'DicomPatientHeadFirstDecibitusRight',
    DicomPatientHeadFirstDecibitusLeft: 'DicomPatientHeadFirstDecibitusLeft',
    DicomPatientFeetFirstSupine: 'DicomPatientFeetFirstSupine',
    DicomPatientFeetFirstProne: 'DicomPatientFeetFirstProne',
    DicomPatientFeetFirstDecibitusRight: 'DicomPatientFeetFirstDecibitusRight',
    DicomPatientFeetFirstDecibitusLeft: 'DicomPatientFeetFirstDecibitusLeft',
    UniCheck: 'UniCheck'
} as const;
export type CoordinateSystem = typeof CoordinateSystem[keyof typeof CoordinateSystem];


export function CoordinateSystemFromJSON(json: any): CoordinateSystem {
    return CoordinateSystemFromJSONTyped(json, false);
}

export function CoordinateSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoordinateSystem {
    return json as CoordinateSystem;
}

export function CoordinateSystemToJSON(value?: CoordinateSystem | null): any {
    return value as any;
}

/**
 * Check if a given object implements the CoordinateSystem interface.
 */
 export function instanceOfCoordinateSystem(value: any): value is CoordinateSystem {
    return Object.values(CoordinateSystem).includes(value)
}

